<template>
  <div id="authorizeFail">
    <div class="message">授权失败，请<span class="exit" @click="exit">退出重试</span></div>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'authorizeFail',
  data () {
    return {
      error: ''
    }
  },
  created () {
    if (this.$route.query.reason) {
      this.error = this.$route.query.reason
    }
  },
  methods: {
    exit () {
      window.close()
    }
  }
}
</script>

<style lang="stylus" scoped>
  #authorizeFail {
    .message {
      margin-top: 30px;
      font-size: 16px;
      font-weight: bold;
      text-align: center
    }
    .error {
      margin-top: 30px;
      text-align center;
      font-size: 14px;
      font-weight: bold
      color: red;
    }
    .exit {
      color: orangered;
      border-bottom  1px solid orangered
    }
  }
</style>